import ArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { ReactNode } from "react";

import EmptyList from "./EmptyList";
import LoadingBackdrop from "./LoadingBackdrop";

const PaginationContainer = ({
  children,
  paginationHistory,
  currentPage,
  pageSize,
  itemCount,
  onPageChange,
  nextPageLink,
  isLoading,
  emptyMessage,
  displayEmptyMessage = true,
}: {
  children: ReactNode;
  paginationHistory: string[];
  currentPage: number;
  pageSize: number;
  itemCount: number;
  onPageChange: (
    nextPageLink: string | undefined,
    paginationHistory: string[]
  ) => void;
  nextPageLink: string;
  isLoading: boolean;
  emptyMessage?: string;
  displayEmptyMessage?: boolean;
}) => {
  const numberOfPages = pageSize ? Math.ceil(itemCount / pageSize) : 1;

  const handlePrevPage = () => {
    const prevPageIndex =
      paginationHistory.length > 1 ? paginationHistory.length - 2 : undefined;
    const prevPage =
      prevPageIndex !== undefined
        ? paginationHistory[prevPageIndex]
        : undefined;
    const otherPages = paginationHistory.slice(0, -1);

    onPageChange(prevPage, otherPages);
  };

  const handleNextPage = () => {
    if (nextPageLink) {
      const newPaginationHistory = [...paginationHistory, nextPageLink];
      onPageChange(nextPageLink, newPaginationHistory);
    }
  };

  return (
    <Box>
      <Box>
        {(itemCount > 0 || !displayEmptyMessage) && children}
        {itemCount === 0 && displayEmptyMessage && (
          <EmptyList message={emptyMessage} />
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {numberOfPages > 1 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              mx: 4,
              mt: 1,
            }}
          >
            <Box>
              <IconButton
                color="inherit"
                size="small"
                sx={{ visibility: "visible" }}
                disabled={currentPage === 1}
                onClick={handlePrevPage}
              >
                <ArrowLeftIcon />
              </IconButton>
            </Box>
            <Box sx={{ mx: 1 }}>
              <Typography
                variant="bodyMedium"
                onClick={handleNextPage}
                sx={{ cursor: "pointer" }}
              >
                Page {currentPage} of {numberOfPages}
              </Typography>
            </Box>
            <Box>
              <IconButton
                color="inherit"
                size="small"
                sx={{ visibility: "visible" }}
                disabled={currentPage === numberOfPages}
                onClick={handleNextPage}
              >
                <ArrowRightIcon />
              </IconButton>
            </Box>
          </Box>
        )}
      </Box>
      {isLoading && <LoadingBackdrop />}
    </Box>
  );
};

export default PaginationContainer;
